// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  seq: __t.u64(),
  at: __t.timestamp(),
  weekIndex: __t.u64().name("week_index"),
  campaign: __t.option(__t.u32()),
  adventure: __t.option(__t.u32()),
  instance: __t.option(__t.u64()),
  pulse: __t.option(__t.u32()),
  kind: __t.byteArray(),
  kindName: __t.string().name("kind_name"),
  actors: __t.byteArray(),
  heroIds: __t.array(__t.u64()).name("hero_ids"),
  npcIds: __t.array(__t.u64()).name("npc_ids"),
  causes: __t.array(__t.u64()),
  visibility: __t.u8(),
  visibilityParty: __t.option(__t.u64()).name("visibility_party"),
  visibilityOwner: __t.option(__t.identity()).name("visibility_owner"),
  summary: __t.string(),
  rulesetVersion: __t.u32().name("ruleset_version"),
});
